import { RESOURCE, ACTIONS } from '../Config';
import { RESPONSE_HEADERS, CONTENT_TYPES } from '../../../../../_Domain/Api/Constants';
import BaseApiService from '../../../../Base/Services/BaseApiService';
import ApiResponseBase from '../../../../Base/Domain/ApiResponseBase';
import PartnerListRequestModel from '../Models/Get/PartnerListRequestModel';
import PartnerListResponseModel from '../Models/Get/PartnerListResponseModel';

const API_ENDPOINT = process.env.REACT_APP_UTILITY_USERINTERFACESERVICES_API_HOST;

class PartnerServicesApiService extends BaseApiService {

  constructor() {
    super(API_ENDPOINT, RESOURCE);
    this.setRequestHeaders({ [RESPONSE_HEADERS.ContentType]: CONTENT_TYPES.ApplicationJson });
  }

  /**
   * @method get
   * @type {GET}
   * @description gets list of published partners
   * 
   * @param {object} model PartnerList request model
   * @returns {Task} PartnerList
   */
  get = async (model) => this._restService.get(new PartnerListRequestModel(model), `${RESOURCE}${ACTIONS.Get}`).then(result => typeof result?.error !== 'undefined' ? new ApiResponseBase(result?.data) : new PartnerListResponseModel(result));

}

export default new PartnerServicesApiService();